import { render, staticRenderFns } from "./NewFeatureRequestPrompt.vue?vue&type=template&id=0c0d2920&scoped=true&"
import script from "./NewFeatureRequestPrompt.vue?vue&type=script&lang=ts&"
export * from "./NewFeatureRequestPrompt.vue?vue&type=script&lang=ts&"
import style0 from "./NewFeatureRequestPrompt.vue?vue&type=style&index=0&id=0c0d2920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d2920",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VFileInput,VProgressCircular,VSnackbar,VSpacer,VTextField,VTextarea})
